import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
@inject('store')
@observer
export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    minute: 0,
    day: 0,
    hour: 0,
    second: 0,
    topReward:[],
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const uid = await setUidToken(this.props.location.query)
    language =await getlangV2(language, lang)
    if (language == 'ar') {
      setDocumentTitle('أيام')
    } else if (language == 'tr') {
      setDocumentTitle('Kural')
    } else {
      setDocumentTitle("Rules")
    }
    this.setState({
      lang: setlang(language, lang),
      language: language,
      uid,
    })

  }


  render() {
    let { language, lang, } = this.state

    return (
      <div className={`newRamadan ${language == 'ar' ? 'arlang' : ''}`}>
          <div className='show-roules' dangerouslySetInnerHTML={{ __html: lang ? lang.ruleDetail : '' }} ></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/rulersRoot/index.js